export enum IntercardInternalPaymentMethodType {
  card = 'card',
}
